export default __webpack_public_path__ + "static/media/Industry-4.0-Sustainable-Development-Webinar.a377c39c.mp4";